module.exports = __webpack_public_path__ + "img/leftastigmatism.fecdf1c8.png";